import './Clinic.css';
import Navbar from '../Navbar/Navbar';
import '../../assets/css/style.css';
import urologyBg1 from '../../assets/img/sidhi/17.png';
import urologyBg2 from '../../assets/img/sidhi/17.png';
import { useState, useEffect } from 'react';
import hitakrilogo from '../../assets/img/hitakrilogo.png';


const Pediatric = () => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
          setCurrentImageIndex((prevIndex) => (prevIndex + 1) % 2);
        }, 4000);

        return () => clearInterval(interval);
      }, []);

    const images = [urologyBg1, urologyBg2];
     const backgroundImage = images[currentImageIndex];
    return (
        <>
        <div className="main-wrapper">
            <header className="header">
                <Navbar />
            </header>

            {/* Breadcrumb */}
            <div className="breadcrumb-bar">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-md-12 col-12">
                            <nav aria-label="breadcrumb" className="page-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item"><a href="/clinic-and-specialities">Our Specialized Medical Departments</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">Pediatrics & Neonatology</li>
                                </ol>
                            </nav>
                            <h2 className="breadcrumb-title">Pediatrics & Neonatology</h2>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Breadcrumb */}

            <div className="content">
              {/* Full-Width Background with Minimal Text */}
                           <div className="urology-header" style={{ backgroundImage: `url(${backgroundImage})` }}>
                                <div className="urology-overlay">
                                    <div className="urology-header-content">
                                        <p>Pediatrics & Neonatology at Hitkari Hospital</p>
                                    </div>
                                </div>
                            </div>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                           
                            <div className="terms-content">
                                <div className="terms-text">
                                    <h3>Pediatrics & Neonatology at Hitkari Hospital</h3>
                                    <p>The Pediatrics & Neonatology Department at Hitkari Hospital is dedicated to specialized care for infants, children, and adolescents, ensuring their optimal growth, development, and immunity.</p>

                                </div>
                                 <div className="terms-text">
                                      <h3>Pediatric Specialties & Conditions Treated</h3>
                                      <br />
                                     <ul>
                                           <li>Neonatal Intensive Care (NICU) for Premature & High-Risk Infants</li>
                                          <li>Pediatric Infectious Diseases & Vaccination Programs</li>
                                          <li>Asthma, Allergies, & Respiratory Disorders</li>
                                          <li>Nutritional Deficiencies & Metabolic Disorders</li>
                                          <li>Congenital Birth Defects & Genetic Conditions</li>
                                            <li>Pediatric Neurology (Epilepsy, Cerebral Palsy, Developmental Delays)</li>
                                          <li>Pediatric Cardiology (Congenital Heart Defects & Rheumatic Heart Disease)</li>
                                    </ul>
                                </div>
                                 <div className="terms-text">
                                    <h3>Advanced Pediatric Services</h3>
                                    <br />
                                       <ul>
                                            <li>Neonatal Ventilation & Surfactant Therapy for premature babies</li>
                                            <li>Pediatric Laparoscopic Surgeries for congenital abnormalities</li>
                                            <li>Child Development Hospital & Behavioral Therapy for Autism & ADHD</li>
                                             <li>Comprehensive Immunization Programs</li>
                                            <li>24/7 Emergency Pediatric & Neonatal Transport Services</li>
                                      </ul>
                                </div>
                                 <div className="terms-text">
                                    <h3>Our Commitment</h3>
                                    <br />
                                   <p>With a specialized team of neonatologists, pediatric intensivists, and child psychologists, we ensure the best start for young lives.</p>
                                </div>
                                 <div className="terms-text">
                                        <h3>Why Choose Hitkari Hospital?</h3>
                                        <ul>
                                            <li>World-Class Infrastructure & Cutting-Edge Technology</li>
                                            <li>Highly Experienced Specialists & Subspecialty Experts</li>
                                            <li>Comprehensive Multidisciplinary Approach to Patient Care</li>
                                            <li>24/7 Emergency & Critical Care Units</li>
                                            <li>Holistic & Preventive Healthcare Programs</li>
                                        </ul>
                                    </div>
                                <div className="terms-text">
                                       <p>For exceptional medical expertise and personalized healthcare solutions, visit Hitkari Hospital in Balotra, Rajasthan.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer className="footer">
            {/* Footer Top */}
            <div className="footer-top">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-about">
                                <div className="footer-logo">
                                    <img src={hitakrilogo} alt="Hitkari Hospital Logo" className="footer-logo-img" style={{ backgroundColor: '#4b8cd681' }} />
                                </div>
                                <div className="footer-about-content">
                                    <p>Your health is our priority. Combining advanced care with a personal touch, our expert team is dedicated to supporting your journey to better health.</p>
                                    <div className="social-icon">
                                        <ul>
                                            <li><a href="https://www.facebook.com/p/Hitkari-Hospital-100063931666732/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a></li>
                                            <li><a href="https://www.instagram.com/hitkarihospital/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-menu">
                                <h2 className="footer-title">For Patients</h2>
                                <ul>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Search for Doctors</a></li>
                                    <li><a href="/privacypolicy"><i className="fas fa-angle-double-right"></i> Privacy-Policy</a></li>
                                    <li><a href="/terms"><i className="fas fa-angle-double-right"></i> Terms-Conditions</a></li>
                                    <li><a href="/booking"><i className="fas fa-angle-double-right"></i> Booking</a></li>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Patient Dashboard</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-menu">
                                <h2 className="footer-title"
                                >
                                    For Patients
                                </h2>
                                <ul>
                                    <li><a href="/appointments"><i className="fas fa-angle-double-right"></i> Appointments</a></li>
                                    <li><a href="/gallery"><i className="fas fa-angle-double-right"></i> Gallery</a></li>
                                    <li><a href="/services"><i className="fas fa-angle-double-right"></i> Services</a></li>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Doctor Dashboard</a></li>
                                    <li><a href="/blogs"><i className="fas fa-angle-double-right"></i> Blogs</a></li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-contact">
                                <h2 className="footer-title">Contact Us</h2>
                                <div className="footer-contact-info" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                                    <div className="footer-address" style={{ display: 'flex', alignItems: 'flex-start' }}>
                                        <a href="https://www.google.com/maps?q=NEAR+MTM+SCHOOL,+BALOTRA" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', textDecoration: 'none', color: 'inherit', alignItems: 'flex-start' }}>
                                            <i className="fas fa-map-marker-alt" style={{ marginRight: '5px' }}></i>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <span>Neelam Cinema Ke Pass, BALOTRA,</span>
                                                <span>DISTT.- BARMER ( RAJASTHAN ),</span>
                                                <span>PIN – 344022</span>
                                            </div>
                                        </a>
                                    </div>
                                    <p style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
                                        <a href="tel:02988223100" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit',marginTop:'18px' }}>
                                            <i className="fas fa fa-phone" style={{ marginRight: '5px' }}></i>
                                            02988-223100
                                        </a>
                                    </p>
                                    <p style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
                                        <a href="mailto:hitkarihospitalblt2015@gmail.com" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit', marginTop:'18px' }}>
                                            <i className="fas fa-envelope" style={{ marginRight: '5px' }}></i>
                                            hitkarihospitalblt2015@gmail.com
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <div className="container-fluid">
                    <div className="copyright">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="copyright-text">
                                    <p className="mb-0">
                                        <a href="/" style={{ color: 'white', textDecoration: 'none' }}>@ Copyright Hitkari Hospital, All rights reserved.</a>
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="copyright-menu">
                                    <ul className="policy-menu">
                                        <li><a href="https://dheersoftwaresolutions.com/" style={{ color: 'white', textDecoration: 'underline', marginRight:'132px' }} target="_blank" rel="noopener noreferrer">Developed By ,Dheer Software Solutions</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        </>
    );
};

export default Pediatric;